<template>
  <div class="modes-icon">
    <div
      class="my-mods-icon"
      v-if="iconClass"
      :class="iconClass"
      :style="{ width: computedWidth, height: computedWidth }"
    >
      <em class="icon iconfont" :class="icon"></em>
    </div>
    <div
      class="my-mods-icon"
      v-else
      :class="wsData | realState(mods) | stateClass(true)"
      :style="{ width: computedWidth, height: computedWidth }"
    >
      <em class="icon iconfont" :class="icon"></em>
    </div>
    <span v-if="showText" class="icon-text" :class="wsData | realState(mods) | stateClass(true)">
      {{ wsData | realState(mods) | stateText | translateTo(i18nPath) }}
      <template v-if="alarmState > 0">-{{ alarmDic[alarmState] | translateTo(i18nPath) }}</template>
    </span>
    <slot />
  </div>
</template>

<script>
import ctt from '@/utils/const';

export default {
  name: 'ModsIcon',
  filters: {
    realState(v, k) {
      if (v && v.mods && v.mods[k]) {
        const { state, runstate } = v.mods[k];
        if (runstate === ctt.RUNSTATE_FAULT) {
          return ctt.POINT_STATE_FAULT;
        } else if (runstate === ctt.RUNSTATE_FIX) {
          if (state === ctt.POINT_STATE_CONNECT) {
            return ctt.POINT_STATE_FIX;
          } else {
            return state;
          }
        } else if (runstate === ctt.RUNSTATE_NORMAL) {
          return state;
        }
      } else {
        return -1;
      }
    }
  },
  props: {
    icon: String,
    i18nPath: {
      type: String,
      default: 'device'
    },
    wsData: Object,
    mods: String,
    getClass: {
      type: [Function, String] /** (wsData) => String */,
      default: null
    },
    alarmState: {
      type: Number,
      default: 0
    },
    alarmDic: {
      type: Array,
      default: () => []
    },
    width: {
      type: [Number, String],
      default: '180px'
    },
    showText: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedWidth() {
      return typeof this.width === 'string' ? this.width : this.width + 'px';
    },
    iconClass() {
      const { wsData } = this;
      if (typeof this.getClass === 'string') return this.getClass;
      if (typeof this.getClass === 'function') return this.getClass(wsData);
      return '';
    }
  }
};
</script>

<style lang="scss">
.modes-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .my-mods-icon {
    position: relative;
    border-radius: 50%;
    color: #00080e;
    @include state-bgstyle;
    em {
      font-size: 5.5em;
      @include pos-center;
    }
  }
  .icon-text {
    display: inline-block;
    @include state-textstyle;
    font-size: 16px;
    margin-top: 8px;
  }
}
</style>
